<template>
  <el-image
    :style="{
      width: size,
      height: size,
      'border-radius': '5px',
      border: '1px solid var(--fm-border-color)',
    }"
    fit="cover"
    :preview-src-list="srcList"
    :src="srcList[0]"
    v-if="srcList && srcList.length > 0"
  ></el-image>
  <el-image
    :style="{
      width: size,
      height: size,
      'border-radius': '5px',
      border: '1px solid var(--fm-border-color)',
    }"
    fit="cover"
    :src="require('@/assets/logo.png')"
    v-else-if="emptyShow"
  ></el-image>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityImage",
  props: {
    commodity: { type: Object },
    commoditySpec: { type: Object },
    preview: { type: Boolean, default: true },
    size: {
      type: [String, Number],
      default: "70px",
    },
    emptyShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    srcList() {
      if (
        this.commoditySpec &&
        this.commoditySpec.imageList &&
        this.commoditySpec.imageList.length > 0
      ) {
        return this.commoditySpec.imageList.map((d) => {
          if (d.sysFile && d.sysFile.prefix) {
            return d.sysFile.prefix + d.sysFile.name;
          }
          return d.url;
        });
      }
      if (
        this.commodity &&
        this.commodity.imageList &&
        this.commodity.imageList.length > 0
      ) {
        return this.commodity.imageList.map((d) => {
          if (d.sysFile && d.sysFile.prefix) {
            return d.sysFile.prefix + d.sysFile.name;
          }
          return d.url;
        });
      }
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/fm/CommodityImage.vue